var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(() => _vm.$emit('close')),expression:"() => $emit('close')"}],staticClass:"popup-menu"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }